export class SupportConfig {
  customerId: string;
  customerName: string;
  userName: string;
  userEmail: string;
}
